@if (formStatus | async; as state) {
  @if (state === actionState.READY && !this.deleteSuccess) {
    <form [formGroup]="detailForm" (keydown.enter)="$event.preventDefault()">
      <h2>{{'stations.form.information' | translate}}</h2>
      <hr>
        <div class="d-flex flex-wrap flex-item-baseline">
          <div class="col-8 d-flex flex-wrap">
            <div class="form-group">
              <label for="name" class="required">{{'stations.form.label.name' | translate}}</label>
              <input formControlName="name" type="text" class="form-control"
                [ngClass]="{'border-danger': f.name.invalid && (f.name.dirty || f.name.touched)}" id="name"
                [placeholder]="'stations.form.placeholder.name' | translate">
              @if (f.name.invalid && (f.name.dirty || f.name.touched)) {
                <div class="alert alert-danger">
                  @if (f.name.errors.required) {
                    <div>
                      {{'error.is_required' | translate}}
                    </div>
                  }
                </div>
              }
            </div>
            <!-- instance
            <div class="form-group">
              <label for="code">{{'stations.form.label.code' | translate}}</label>
              <input formControlName="code" type="text" class="form-control" id="code"
                [placeholder]="'stations.form.placeholder.code' | translate">
            </div> -->
            <!-- ENERGIES -->
            <div class="form-group">
              <label for="energies" class="required">{{'stations.form.label.type' | translate}}</label>
              @for (energyOpt of stationEnergyList; track energyOpt; let isFirst = $first) {
                <div class="d-inline-block">
                  <input type="checkbox" class="form-control" [value]="energyOpt" [id]="energyOpt"
                    [checked]="selectedEnergies.indexOf(energyOpt) !== -1"
                    (click)="onCheckboxClicked($event, detailCheckboxType.ENERGY)"
                    [disabled]="detailForm.disabled">
                  <label [htmlFor]="energyOpt">
                    {{'stations.energy.' + energyOpt | translate}}
                  </label>
                </div>
              }
              @if (f.energies.invalid) {
                <div class="alert alert-danger">
                  @if (f.energies.errors.required) {
                    <div>
                      {{'error.is_required' | translate}}
                    </div>
                  }
                </div>
              }
            </div>
            <!-- SERVICE -->
            <div class="form-group">
              <label class="d-block" class="required">{{'stations.form.label.service' | translate}}</label>
              @for (serviceOpt of stationServiceList; track serviceOpt; let isFirst = $first) {
                <div class="d-inline-block">
                  <input formControlName="service" type="radio" class="form-control" [value]="serviceOpt"
                    [id]="'vi-' + serviceOpt" [checked]="isFirst">
                  <label [htmlFor]="'vi-' + serviceOpt">
                    {{'stations.service.' + serviceOpt | translate}}
                  </label>
                </div>
              }
              @if (f.service.invalid) {
                <div class="alert alert-danger">
                  @if (f.service.errors.required && (f.service.dirty || f.service.touched)) {
                    <div>
                      {{'error.is_required' | translate}}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <!-- ABOUT -->
          <div class="col-4">
            <div class="form-group">
              <label for="about">{{'stations.form.label.about' | translate}}</label>
              <textarea formControlName="about" class="form-control" id="about"
              [placeholder]="'stations.form.placeholder.about' | translate"></textarea>
            </div>
          </div>
          <!-- ADDRESS -->
          <div class="form-group">
            <label class="required">{{'stations.form.label.address' | translate}}</label>
            <span class="localisation">
              <input [matAutocomplete]="addressAutocomplete" matAutocompletePosition="below"
                class="form-control" (input)="onAddressInputChange(f.address.value)"
                [ngClass]="{'border-danger': f.address.invalid && (f.address.dirty || f.address.touched)}"
                formControlName="address" />
              <mat-autocomplete #addressAutocomplete="matAutocomplete" class="input-autocomplete"
                disableRipple=true (optionSelected)="selectAddress($event.option.value)">
                @for (address of addressList; track address) {
                  <mat-option [value]="address">
                    {{ address.properties ? address.properties.label : 'stations.form.message.error.no_address' | translate}}
                  </mat-option>
                }
              </mat-autocomplete>
            </span>
            <!-- <div *ngIf="invalidAddress" class="alert alert-danger">
            {{ 'stations.form.message.error.invalid_address' | translate}}
          </div> -->
          @if (f.address.invalid && (f.address.dirty || f.address.touched)) {
            <div class="alert alert-danger">
              @if (f.address.errors.required) {
                <div>
                  {{'error.is_required' | translate}}
                </div>
              }
            </div>
          }
        </div>
        <div class="form-group d-flex flex-wrap">
          <!-- STREET NUMBER -->
          <div class="form-group">
            <label for="streetNumber">{{'stations.form.label.streetNumber' | translate}}</label>
            <span class="localisation">
              <input formControlName="streetNumber" type="text" class="form-control" id="streetNumber"
                [placeholder]="'stations.form.placeholder.streetNumber' | translate">
            </span>
            <!-- <div *ngIf="f.streetNumber.invalid && (f.streetNumber.dirty || f.streetNumber.touched)" class="alert alert-danger">
            <div *ngIf="f.streetNumber.errors.required">
              {{'error.is_required' | translate}}
            </div>
          </div> -->
        </div>
        <!-- LOCALITY -->
        <div class="form-group">
          <label for="locality" class="required">{{'stations.form.label.locality' | translate}}</label>
          <span class="localisation">
            <input formControlName="locality" type="text" class="form-control" id="locality"
              [placeholder]="'stations.form.placeholder.locality' | translate">
          </span>
          @if (f.locality.invalid && (f.locality.dirty || f.locality.touched)) {
            <div class="alert alert-danger">
              @if (f.locality.errors.required) {
                <div>
                  {{'error.is_required' | translate}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <!-- POSTAL CODE -->
      <div class="form-group">
        <label for="postalCode" class="required">{{'stations.form.label.postalCode' | translate}}</label>
        <span class="localisation">
          <input formControlName="postalCode" type="text" class="form-control" id="postalCode"
            [placeholder]="'stations.form.placeholder.postalCode' | translate">
        </span>
        @if (f.postalCode.invalid && (f.postalCode.dirty || f.postalCode.touched)) {
          <div class="alert alert-danger">
            @if (f.postalCode.errors.required) {
              <div>
                {{'error.is_required' | translate}}
              </div>
            }
          </div>
        }
      </div>
      <div class="form-group d-flex flex-wrap">
        <!-- LATITUDE -->
        <div class="form-group">
          <label for="locality" class="required">{{'stations.form.label.latitude' | translate}}</label>
          <span class="localisation">
            <input formControlName="latitude" type="text" class="form-control" id="latitude"
              [placeholder]="'stations.form.placeholder.latitude' | translate">
          </span>
          @if (f.latitude.invalid && (f.latitude.dirty || f.latitude.touched)) {
            <div class="alert alert-danger">
              @if (f.latitude.errors.required) {
                <div>
                  {{'error.is_required' | translate}}
                </div>
              }
            </div>
          }
        </div>
        <!-- LONGITUDE -->
        <div class="form-group">
          <label for="locality" class="required">{{'stations.form.label.longitude' | translate}}</label>
          <span class="localisation">
            <input formControlName="longitude" type="text" class="form-control" id="longitude"
              [placeholder]="'stations.form.placeholder.longitude' | translate">
          </span>
          @if (f.longitude.invalid && (f.longitude.dirty || f.longitude.touched)) {
            <div class="alert alert-danger">
              @if (f.longitude.errors.required) {
                <div>
                  {{'error.is_required' | translate}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group d-flex flex-wrap">
        <!-- EMAIL -->
        <div class="form-group">
          <label for="email">{{'stations.form.label.email' | translate}}</label>
          <input formControlName="email" type="email" class="form-control" id="email"
            [placeholder]="'stations.form.placeholder.email' | translate">
          @if (f.email.invalid && (f.email.dirty || f.email.touched)) {
            <div class="alert alert-danger">
              @if (f.email.errors.pattern) {
                <div>
                  {{'error.pattern' | translate}}
                </div>
              }
            </div>
          }
        </div>
        <!-- PHONE -->
        <div class="form-group">
          <label for="phone">{{'stations.form.label.phone' | translate}}</label>
          <input formControlName="phone" type="phone" class="form-control" id="phone"
            [placeholder]="'stations.form.placeholder.phone' | translate">
          @if (f.phone.invalid && (f.phone.dirty || f.phone.touched)) {
            <div class="alert alert-danger">
              @if (f.phone.errors.pattern) {
                <div>
                  {{'error.pattern' | translate}}
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group"></div>
      <!-- instance
      <div class="form-group d-flex flex-wrap">
        <!- VISIBILITY ->
        <div class="form-group">
          <label class="d-block" class="required">{{'stations.form.label.visibility' | translate}}</label>
          <div *ngFor="let visibilityOpt of stationVisibilityList; let isFirst = first"
            class="d-inline-block">
            <input formControlName="visibility" type="radio" class="form-control" [value]="visibilityOpt"
              [id]="'vi-' + visibilityOpt" [checked]="isFirst">
            <label [htmlFor]="'vi-' + visibilityOpt">
              {{'stations.visibility.' + visibilityOpt | translate}}
            </label>
          </div>
          <div *ngIf="f.visibility.invalid" class="alert alert-danger">
            <div *ngIf="f.visibility.errors.required && (f.visibility.dirty || f.visibility.touched)">
              {{'error.is_required' | translate}}
            </div>
          </div>
        </div>
      </div> -->
      <!-- ACCES -->
      <!-- <div class="form-group">
      <label class="d-block">{{'stations.form.label.access' | translate}}</label>
      <div *ngFor="let accessOpt of accessTypeList; let isFirst = first" class="d-inline-block">
        <input formControlName="access" type="radio" class="form-control" [value]="accessOpt"
          [id]="'ac-' + accessOpt" [checked]="!isDetailView ? isFirst : accessOpt === station.access">
        <label [htmlFor]="'ac-' + accessOpt">
          {{'stations.access.' + accessOpt | translate}}
        </label>
      </div>
      <div *ngIf="f.access.invalid" class="alert alert-danger">
        <div *ngIf="f.access.errors.required && (f.access.dirty || f.access.touched)">
          {{'error.is_required' | translate}}
        </div>
      </div>
    </div> -->
    <!-- VEHICLES -->
    <!-- <div class="form-group">
    <label class="d-block" class="required">{{'stations.form.label.authorized_vehicles' | translate}}</label>
    <div *ngFor="let vehicleOpt of vehicleTypeList; let isFirst = first" class="d-inline-block">
      <input type="checkbox" class="form-control" [value]="vehicleOpt" [id]="vehicleOpt"
        [checked]="selectedVehicles.indexOf(vehicleOpt) !== -1"
        (click)="onCheckboxClicked($event, detailCheckboxType.VEHICLE)"
        [disabled]="detailForm.disabled">
      <label [htmlFor]="vehicleOpt">
        {{'vehicles.' + vehicleOpt | translate}}
      </label>
    </div>
    <div *ngIf="f.authorizedVehicles.invalid" class="alert alert-danger">
      <div *ngIf="f.authorizedVehicles.errors.required">
        {{'error.is_required' | translate}}
      </div>
    </div>
  </div> -->
  <!-- PAYMENT -->
  <!-- <div class="form-group">
  <label class="d-block" class="required">{{'stations.form.label.payment' | translate}}</label>
  <div *ngFor="let paymentOpt of stationPaymentList; let isFirst = first" class="d-inline-block">
    <input type="checkbox" class="form-control" [value]="paymentOpt" [id]="paymentOpt"
      [checked]="selectedPayment.indexOf(paymentOpt) !== -1"
      (click)="onCheckboxClicked($event, detailCheckboxType.PAYMENT)"
      [disabled]="detailForm.disabled">
    <label [htmlFor]="paymentOpt">
      {{'stations.payment.' + paymentOpt | translate}}
    </label>
  </div>
  <div *ngIf="f.paymentTypes.invalid" class="alert alert-danger">
    <div *ngIf="f.paymentTypes.errors.required">
      {{'error.is_required' | translate}}
    </div>
  </div>
</div> -->
<!-- OCCUPANCY -->
<!-- <div class="form-group" *ngIf="displayOccupancy">
<label class="d-block">{{'occupancy.title' | translate}}</label>
<input formControlName="showOccupancy" type="checkbox" class="form-control" id="showOccupancy" [ngClass]="{'border-danger': f.showOccupancy.invalid && (f.showOccupancy.dirty || f.type.touched)}">
<label [htmlFor]="'showOccupancy'">{{'stations.form.label.showOccupancy' | translate}}</label>
<app-station-occupancy [eUid]="station.uid"></app-station-occupancy>
</div> -->
@if (f.lastActivity.value.length > 0) {
  <div class="form-group">
    <label for="lastActivity">{{'stations.form.label.last_activity' | translate}}</label>
    <span>{{f.lastActivity.value}}</span>
  </div>
}
</div>
@if (isDetailView) {
  <a href="javascript:void(0);" type="button" class="delete-station text--danger"
    [ngClass]="{'disabled': !isEditting}" (click)="openDialog(station)">
    {{'action.delete_station' | translate }}
  </a>
}
<!-- Success message for Station Detail view -->
@if (successMessage) {
  <div class="alert alert-success">
    {{successMessage}}
  </div>
}
<div class="mt-20 text-right">
  <!-- Station detail view -->
  @if (isDetailView) {
    <div>
      @if (!isEditting) {
        <div>
          <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" type="button" class="btn btn--primary"
          (click)="editForm()">{{ 'action.edit' | translate }}</button>
        </div>
      } @else {
        <button type="button" class="btn btn--primary" (click)="onSubmitForm(false)">
          {{ 'action.submit' | translate }}
        </button>
        <button class="btn btn--outline-grey-color ml-20" (click)="cancelEditingForm()">
          {{'action.cancel' | translate }}
        </button>
      }
    </div>
  } @else {
    <button type="button" class="btn btn--primary"
    (click)="onSubmitForm(false)">{{ 'action.submit' | translate }}</button>
    <button type="button" class="btn btn--outline-main-color ml-20" (click)="onSubmitForm(true)">
      {{ 'action.submit_and_configure' | translate }}
    </button>
    <button type="button" [routerLink]="currentRoute.pathSlash" class="btn btn--outline-grey-color ml-20"
    [translate]="'action.cancel'"></button>
  }
  <!-- Station creation view -->
</div>
<!-- <pre>
Value : {{detailForm.value | json}}
</pre> -->
</form>
}
@if (state === actionState.READY && this.deleteSuccess) {
  <div class="alert alert-success delete-success__ctn">
    {{deleteSuccess}}
    <app-jumping-dots></app-jumping-dots>
  </div>
}
<!-- Success message for Station creation view  -->
@if (state === actionState.SUCCESS && !isDetailView) {
  <div class="success__ctn">
    <div class="alert alert-success">
      {{'stations.form.message.success.content' | translate}}
    </div>
    <div class="d-flex">
      <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary mr-5" (click)="goToCreatedStation()">
        {{'action.show_station' | translate}}
      </button>
      <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-main-color ml-5" [routerLink]="currentRoute.pathSlash">
        {{'action.back_to_list' | translate}}
      </button>
    </div>
  </div>
}
<!-- Loading  -->
@if (state === actionState.LOADING) {
  <span class="ui-loading" [model]="{isLoading: true}"></span>
}
}